// Entry point for the build script in your package.json

import { Turbo } from "@hotwired/turbo-rails"
Turbo.start()

import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

import "@fortawesome/fontawesome-free/js/fontawesome";

import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/brands";
import "@fortawesome/fontawesome-free/js/regular";

import $ from "jquery";
window.$ = window.jQuery = $;

import { tns } from "tiny-slider";
window.tns = tns;

import "./main"
import "./controllers"
import "./opsico-template/opsico-template"